import {
  NEGATIVE_FILTER_TOKEN,
  SEPARATOR,
} from '@hakimo-ui/hakimo/data-access';
import {
  FilterValues,
  TimeFilterValue,
  TimePeriod,
} from '@hakimo-ui/hakimo/types';
import { getStartEndTimes, getMHFromTimePeriod } from '@hakimo-ui/hakimo/util';
import { useMemo } from 'react';

function getFilterQuery(values: string[], negative: boolean): string {
  const query = values;
  if (negative) {
    query.push(NEGATIVE_FILTER_TOKEN);
  }
  return query.join(SEPARATOR);
}

export const getSearchParams = (
  page: number,
  pageSize: number,
  values: Partial<FilterValues>
) => {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('pageSize', String(pageSize));
  if (values.location && values.location.values.length > 0) {
    const query = getFilterQuery(
      values.location.values.map((item) => item.id),
      values.location.negative
    );
    params.append('locationIds', query);
  }
  if (values.status && values.status.values.length > 0) {
    const statusQuery: string[] = [...values.status.values];
    const query = getFilterQuery(statusQuery, values.status.negative);
    params.append('statuses', query);
  }
  if (values.time && values.time.period !== TimePeriod.ALL_TIME) {
    if (values.time.period === TimePeriod.CUSTOM_RANGE) {
      const [startTime, endTime] = getStartEndTimes(values.time);
      params.append('dateFrom', String(startTime));
      params.append('dateTo', String(endTime));
    } else {
      const [minutes, hours] = getMHFromTimePeriod(values.time.period);
      if (hours) {
        params.append('relativeTimeHours', String(hours));
      }
      if (minutes) {
        params.append('relativeTimeMinutes', String(minutes));
      }
    }
  }
  return params.toString();
};

export function useWithTimeFilterValue<T>(currentValue: T, period: TimePeriod) {
  const alarmListFilters: T & {
    time: TimeFilterValue;
  } = useMemo(
    () => ({
      time: {
        period,
        customRangeStart: 0,
        customRangeEnd: 0,
      },
      ...currentValue,
    }),
    [currentValue, period]
  );

  return alarmListFilters;
}
